import type { BodyMeasurementLogConfig } from "@/lib/schema";
import type { WidgetValidationResult } from "@/widgets/types";

export function validate(
  config: BodyMeasurementLogConfig,
): WidgetValidationResult {
  const errors: Record<string, string> = {};
  if (config.label.trim().length === 0) {
    errors.label = "Etikett kan ikke være tom.";
  }
  if (config.types.length === 0) {
    errors.types = "Velg minst én måling.";
  }
  if (Object.keys(errors).length === 0) return { ok: true };
  return { ok: false, errors };
}
